import React from 'react';
const IconRatingThumbsDownFill = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M20 4V15H22V4H20ZM2 10.6V14C2 14.7956 2.31607 15.5587 2.87868 16.1213C3.44129 16.6839 4.20435 17 5 17H9V20C9 20.5304 9.21071 21.0391 9.58579 21.4142C9.96086 21.7893 10.4696 22 11 22H12.43L18 15.36V4H7.53L2 10.6Z" fill="#2D2E2E"/>
</svg>
);
};
export default IconRatingThumbsDownFill;